var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('index'),_c('swiper'),_c('keep-alive',{attrs:{"include":"Home"}},[_c('router-view')],1),_c('bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }